import { ExpedientesService } from './../../services/expedientes.service';
import { MensajesService } from './../../services/mensajes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  nuevosMensajes=0;
  nuevosExpedientes=0;
  ordenacion={campo: "MEfecha", orden: "DESC"};

  constructor(private auth:AuthService, private mensajesService:MensajesService, 
              private expedientesService:ExpedientesService) { 
    if(this.auth.getToken()){
      this.mensajesService.getMensajesNoLeidos(this.auth.usuarioActivo, this.ordenacion)
      .subscribe(resp=>{
        this.nuevosMensajes=resp["mensajesRecibidos"].length;
      });

      if(this.auth.esAdmin()){
        this.getNuevosExpedientes();
      }
    }

    
  }

  ngOnInit() {
  }

  getNuevosExpedientes(){
    this.expedientesService.nuevosExpedientes()
    .subscribe(resp=>{
      this.nuevosExpedientes=resp["total_registros"];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts